// The warranty line on customer quote documents (quote PDF + portal quote page) — the ONE owner
// (operator ruling 2026-10-24 #7, board #6118; docs/PRODUCT_DECISIONS.md "Customer documents and
// links" #4: "when a warranty is set, print 'Warranty: ...' and its terms").
//
// Source: work_orders.warranty_duration_days (integer, days from completion — the same start
// apps/contractor-app/src/utils/warrantyStatus.js counts from) and work_orders.warranty_terms
// (free text). The Quote Builder writes both.
//
// Returns null when the quote has no warranty, so each document keeps its existing look. The
// warranty IS the duration: the Quote Builder shows the terms box only once a duration is picked,
// and "No warranty" clears the duration but can leave old terms behind (QuoteBuilder), so terms
// without a duration are not a warranty and print nothing.

/**
 * @param {{warranty_duration_days?: number|string|null, warranty_terms?: string|null}} record
 * @returns {{ heading: string, terms: string } | null}
 *   heading  "Warranty: 90 days from completion"
 *   terms    the warranty terms, trimmed ('' when none)
 */
export function documentWarranty(record) {
  if (!record) return null;
  const days = Math.floor(Number(record.warranty_duration_days));
  const hasDays = Number.isFinite(days) && days > 0;
  const terms = String(record.warranty_terms ?? '').trim();
  if (!hasDays) return null;
  return { heading: `Warranty: ${days} ${days === 1 ? 'day' : 'days'} from completion`, terms };
}
